import { action } from 'mobx'

import { APIStatus } from '@flowwai-frontend/shared/api-common'
import {
   useAsyncWithAuth,
   useAuthSession
} from '@flowwai-frontend/shared/auth/common'
import {
   HOME_ROUTE_PATH,
   LOGIN_ROUTE_PATH
} from '@flowwai-frontend/bps-officer-web/common/data-access'

import { setPath } from '../../utils/StorageUtils'
import { useLogoutService } from '../services/useLogoutService'
import { LogoutAPIRequestType } from '../../services/types'

export interface UseLogoutAPIReturnType {
   logout: (
      requestObj: LogoutAPIRequestType,
      onSuccessArg?: () => void,
      onFailureArg?: (error: Error) => void
   ) => void
   logoutAPIStatus: APIStatus
   logoutAPIError: Error | null
}

const useLogoutAPI = (): UseLogoutAPIReturnType => {
   const logoutService = useLogoutService()
   const { clearAllCookies } = useAuthSession()

   const {
      triggerAPI: logoutAPI,
      apiStatus: logoutAPIStatus,
      error: logoutAPIError
   } = useAsyncWithAuth(logoutService.logoutAPI)

   const onSuccess = (): void => {
      clearAllCookies()

      setPath(HOME_ROUTE_PATH)

      window.location.href = LOGIN_ROUTE_PATH
   }

   const logout = (
      requestObj: LogoutAPIRequestType,
      onSuccessArg?: () => void,
      onFailureArg?: (error: Error) => void
   ): void => {
      const handleOnSuccess = action((): void => {
         onSuccess()
         onSuccessArg && onSuccessArg()
      })

      logoutAPI(requestObj, {
         onSuccess: handleOnSuccess,
         onError: onFailureArg
      })
   }

   return { logout, logoutAPIStatus, logoutAPIError }
}

export { useLogoutAPI }
